// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"2442":"c1cfabdd463c2d4c","5443":"ae7cb0da2c89ee97","6350":"060e0278f0f8257a","7666":"bb4cfe42d39c30c9"}[chunkId] + ".js";
};